import FilterPanel from './FilterPanel.vue';

export default FilterPanel;
